import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchCampaignPerformance } from '@/lib/venue/campaignPerformanceApi'
import type { PerformanceListFilter } from '@/lib/venue/campaignPerformanceViewModel'

export function campaignPerformanceQueryKey(venueId: string, filter: PerformanceListFilter) {
  return ['venue', venueId, 'campaign-performance', filter] as const
}

/**
 * 성과 목록(#734 §1-3) — `useCampaigns`와 동일하게 서버가 이미 인코딩한 `nextCursor`를 그대로 쓴다.
 * 🚨 `useCampaigns`(작성일 축)와 쿼리 키·커서를 절대 공유하지 않는다 — 두 EP의 커서는 호환되지
 * 않는다(#736 §1).
 */
export function useCampaignPerformance(
  venueId: string,
  filter: PerformanceListFilter,
  options: { enabled?: boolean } = {}
) {
  return useInfiniteQuery({
    queryKey: campaignPerformanceQueryKey(venueId, filter),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchCampaignPerformance(venueId, filter, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
    enabled: options.enabled ?? true,
  })
}
